import { useEffect, useRef } from "react";

export const useScrollDirectionClass = (
  containerIds = ["scrollableDivGroups", "scrollableDivUsers", "scrollableDivModule", "scrollableDivApplication"]
) => {
  const lastScrollTopMap = useRef({});

  useEffect(() => {
    const listeners = [];

    containerIds.forEach((id) => {
      const container = document.getElementById(id);
      if (!container) return;

      const handleScroll = () => {
        const scrollTop = container.scrollTop;
        const lastScrollTop = lastScrollTopMap.current[id] || 0;

        const teamInfo = document.querySelector(".team-info");
        const withSearch = document.querySelector(".with-search");
        // const sliderContainer = document.querySelector(".slider-container");
        // const mobHeader = document.querySelector(".mob-header");

        // Always hide when scrolled, regardless of direction
        if (scrollTop > 10) {
          teamInfo?.classList.add("teaminforemoved");
          withSearch?.classList.add("tabscrolled");
          // sliderContainer?.classList.add("scrolled-up");
          // mobHeader?.classList.add("scrolled-up");
        }

        // Show again only when at the top
        if (scrollTop === 0) {
          teamInfo?.classList.remove("teaminforemoved");
          withSearch?.classList.remove("tabscrolled");
          // sliderContainer?.classList.remove("scrolled-up");
          // mobHeader?.classList.remove("scrolled-up");
        }

        lastScrollTopMap.current[id] = scrollTop <= 0 ? 0 : scrollTop;
      };

      container.addEventListener("scroll", handleScroll);
      listeners.push({ container, handleScroll });
    });

    return () => {
      listeners.forEach(({ container, handleScroll }) => {
        container.removeEventListener("scroll", handleScroll);
      });
    };
  }, [containerIds]);
};
